// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GMra","footer":"styles_footer__10eaR"};